var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "cms-block-banners",
      class: {
        "m-t_Office":
          _vm.getRootCategorySlug === _vm.config.rootcategories.biuro
      }
    },
    [
      _c(
        "no-ssr",
        [
          _vm.showCarousel && _vm.getBanners().length > 0
            ? _c(
                "carousel",
                {
                  attrs: {
                    "per-page": 1,
                    "navigation-enabled": false,
                    "pagination-enabled": true,
                    "autoplay-hover-pause": true,
                    "autoplay-timeout": 8000,
                    speed: 1000,
                    autoplay: true,
                    loop: true,
                    "pagination-active-color": "#f26190",
                    "pagination-color": "#ffffff"
                  }
                },
                _vm._l(_vm.getBanners(), function(slide, index) {
                  return _c("slide", { key: index }, [
                    _c("a", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy:background-image",
                          value: _vm.getImagePath(slide),
                          expression: "getImagePath(slide)",
                          arg: "background-image"
                        }
                      ],
                      staticClass: "item",
                      style: _vm.getItemStyle(),
                      attrs: { href: slide.link, title: slide.title }
                    })
                  ])
                }),
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }